import React from "react";
import {
  Autoplay,
  FreeMode,
  Keyboard,
  Mousewheel,
  Navigation,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import UseGeneral from "../../../hooks/useGeneral";
import "./style.css";
import { Loader } from "rsuite";
import ContentLoader from "react-content-loader";
import { ThreeDots } from "react-loader-spinner";
const Brands = ({ brands }) => {
  const { language } = UseGeneral();
  const studiesswiper = {
    slidesPerView: 2,
    slidesPerColumn: 1,
    spaceBetween: 10,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      620: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 50,
      },
    },
  };
  return (
    <>
      {!brands ? (
        <span
          style={{
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ThreeDots />
       
        </span>
      ) : brands.length ? (
        <>
          <h3
            style={{
              textAlign: "center",
              fontSize: "35px",
              fontWeight: 700,
              marginTop: "56px",
            }}
          >
            {language == "ar" ? "أشهر العلامات" : "The most famous signs"}
          </h3>
          <div className="rowDiv bannerDiv" style={{ marginBottom: "65px" }}>
            <Swiper
              spaceBetween={20}
              slidesPerView={3}
              // navigation={true}
              modules={[FreeMode, Autoplay, Navigation, Mousewheel, Keyboard]}
              // pagination={{ clickable: true }}
              autoplay={{ delay: 5000 }}
              loop={true}
              dir={language != "en" ? "rtl" : "ltr"}
              key={language != "en"}
              {...studiesswiper}
            >
              {brands?.map((item, index) => (
                <SwiperSlide
                  key={index}
                  onClick={() => window?.open(item?.link, "_blanck")}
                  className="d-flex"
                >
                  <img style={{
                    marginInline:'auto'
                  }} src={item?.url} alt="" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </>
      ) : null}
    </>
  );
};

export default Brands;
